import * as React from 'react';

/**
 * Ícone institucional de alto contraste (círculo meio preenchido).
 *
 * O arquivo de origem vem num viewBox de 40×40 com o desenho centralizado
 * ocupando 20 unidades; o viewBox foi recortado para `8 8 24 24` de modo que
 * a proporção conteúdo/moldura fique igual à do [AccessibilityIcon] e o ícone
 * renderize no tamanho certo pela classe, sem width/height fixos.
 */
export const ContrastIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="8 8 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M20 10.25C18.0716 10.25 16.1866 10.8218 14.5832 11.8932C12.9798 12.9645 11.7301 14.4873 10.9922 16.2688C10.2542 18.0504 10.0611 20.0108 10.4373 21.9021C10.8136 23.7934 11.7422 25.5307 13.1057 26.8943C14.4693 28.2579 16.2066 29.1865 18.0979 29.5627C19.9892 29.9389 21.9496 29.7458 23.7312 29.0078C25.5127 28.2699 27.0355 27.0202 28.1068 25.4168C29.1782 23.8134 29.75 21.9284 29.75 20C29.7473 17.415 28.7192 14.9366 26.8913 13.1087C25.0634 11.2808 22.585 10.2527 20 10.25ZM20.75 11.7847C21.2577 11.831 21.76 11.9252 22.25 12.0659V27.9378C21.76 28.0786 21.2577 28.1727 20.75 28.2191V11.7847ZM23.75 12.6528C24.2845 12.9265 24.7875 13.2578 25.25 13.6409V26.3591C24.7875 26.7422 24.2845 27.0735 23.75 27.3472V12.6528ZM11.75 20C11.7525 17.9426 12.5227 15.9601 13.9098 14.4406C15.297 12.9212 17.2013 11.9741 19.25 11.7847V28.2153C17.2013 28.0259 15.297 27.0788 13.9098 25.5594C12.5227 24.0399 11.75 22.0574 11.75 20ZM26.75 24.7381V15.2619C27.7262 16.649 28.25 18.3038 28.25 20C28.25 21.6962 27.7262 23.351 26.75 24.7381Z"
      fill="currentColor"
    />
  </svg>
);

export default ContrastIcon;
